import React, { useState, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import Loader from '../theme/Loader'
import Avatar from '@mui/material/Avatar';
import { updateUserPassword, logout } from '../../actions/userActions'
import Paper from '@mui/material/Paper';
import FormGroup from '@mui/material/FormGroup';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';

function ProfilePage() {


    const [currentPassword, setCurrentPassword] = useState('')
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [successMessage, setSuccessMessage] = useState('')
    const [errorMessage, setErrorMessage] = useState('')
    const [submitActive, setSubmitActive] = useState(true)
    const dispatch = useDispatch()
    const userDetails = useSelector(state => state.userDetails)
    const userLogin = useSelector(state => state.userLogin)
    const { error, loading, user } = userDetails
    const userUpdateProfile = useSelector(state => state.userUpdateProfile)

    const lengthPassMessage = useMemo(() => {
        if (password.length < 8) {
            return "Password must be at least 8 characters long"
        }
        else {
            return ""
        }
    }, [password,
    ])

    const characterPassMessage = useMemo(() => {
        if (! /[a-zA-Z]/.test(password)) {
            return "Password must contain at least one letter"
        }
        else {
            return ""
        }
    }, [password
    ])


    const digitsPassMessage = useMemo(() => {
        if (! /\d/.test(password)) {
            return "Password must contain at least one digit"
        }
        else {
            return ""
        }
    }, [password
    ])



    const englishPassMessage = useMemo(() => {
        if (/[^\x00-\x7F]/.test(password)) {
            return "Password must contain at least one letter"
        }
        else {
            return ""
        }
    }, [password
    ])

    useEffect(() => {
        if (userUpdateProfile.error) {

            setErrorMessage(userUpdateProfile.error)
        }
        else if (userUpdateProfile.success) {
            setSuccessMessage("Password Updates!")
            setErrorMessage('')
            setPassword('')
            setConfirmPassword('')
        }


    },

        [userUpdateProfile.error,
        userUpdateProfile.success
        ]
    )


    function stringToColor(string) {
        let hash = 0;
        let i;

        /* eslint-disable no-bitwise */
        for (i = 0; i < string.length; i += 1) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }

        let color = '#';

        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }
        /* eslint-enable no-bitwise */

        return color;
    }

    function stringAvatar(name) {
        return {
            sx: {
                bgcolor: stringToColor(name),
            },
            children: `${name.length > 0 ? name[0] : "a"}`,
        };
    }




    useEffect(() => {

        if (password.length >= 8
            && /[a-zA-Z]/.test(password)
            && /\d/.test(password)
            && !/[^\x00-\x7F]/.test(password)
            && password === confirmPassword) {
            setSubmitActive(false)

        }
        else {
            setSubmitActive(true)

        }

    }, [password, confirmPassword]);




    const submitHandler = (e) => {
        e.preventDefault()


        if (password !== confirmPassword) {
            setErrorMessage("Passwords do not match")
            setSuccessMessage('')
        } else {
            dispatch(updateUserPassword(currentPassword, password))

        }

    }
    return (
        <>
            {userLogin && userLogin.todoUserInfo && Object.keys(userLogin.todoUserInfo).length>0?
                <>
                    {user && user.username ?

                        <Grid container spacing={0} sx={{
                            alignItems: "center", justifyContent: "center",
                            m: 10
                        }}>
                            <Grid>
                                <Paper sx={{ p: 3 }}>
                                    <IconButton
                                        sx={{ p: 0 }}
                                    >
                                        <Avatar alt={user.username} {...stringAvatar(user.username)} />
                                    </IconButton>
                                    <Box sx={{}} >
                                        <Typography variant="h4">
                                            {"User Profile"}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ textAlign: "left", ml: 3, mr: 3 }} >
                                        <Typography variant="h5"
                                            sx={{ textAlign: "center", ml: 3, mr: 3, mb: 5 }}
                                        >
                                            {user.username}
                                        </Typography>
                                        <Typography variant="h7">
                                            {`Full Name: ${user.first_name} ${user.last_name}`}
                                        </Typography>
                                        <br />
                                        <Typography variant="h7">
                                            {`Email: ${user.email}`}
                                        </Typography>
                                    </Box>
                                    <Box sx={{}} >
                                        {errorMessage && <Alert variant="filled" severity="error">{errorMessage}</Alert>}
                                        {successMessage && <Alert variant="filled" severity="success">{successMessage}</Alert>}
                                        {error && <Alert variant="filled" severity="error">{error}</Alert>}
                                    </Box>
                                    {loading && <Loader />}
                                    <Button
                                        type="submit"
                                        // fullWidth
                                        variant="contained"
                                        color="primary"
                                        sx={{ m: 3 }}
                                        onClick={() => { dispatch(logout()) }}

                                    >
                                        {"Sign Out"}
                                    </Button>
                                    <Box sx={{}} >
                                        <FormControl
                                            sx={{ minWidth: "20vw" }}>
                                            <FormGroup
                                            >

                                                <Box sx={{
                                                    textAlign: "center",
                                                }} >
                                                    <br />
                                                    <Typography
                                                        sx={{
                                                            fontSize: "1.2em",
                                                            fontStyle: "bold"
                                                        }}>
                                                        {"Update Password"}
                                                    </Typography>
                                                    <Typography
                                                        sx={{ fontSize: "0.9em" }}
                                                        display="block"
                                                        color="error">
                                                        {lengthPassMessage}
                                                    </Typography>

                                                    <Typography
                                                        sx={{ fontSize: "0.9em" }}
                                                        display="block"
                                                        color="error">
                                                        {digitsPassMessage}
                                                    </Typography>

                                                    <Typography
                                                        sx={{ fontSize: "0.9em" }}
                                                        display="block"
                                                        color="error">
                                                        {characterPassMessage}
                                                    </Typography>

                                                    <Typography
                                                        sx={{ fontSize: "0.9em" }}
                                                        display="block"
                                                        color="error">
                                                        {englishPassMessage}
                                                    </Typography>

                                                </Box>
                                                <TextField
                                                    variant="outlined"
                                                    margin="normal"
                                                    required
                                                    sx={{ mr: 3, ml: 3 }}
                                                    id="current-password"
                                                    label={"Current Password"}
                                                    name="current-password"
                                                    autoComplete="current-password"
                                                    value={currentPassword}
                                                    type="password"
                                                    autoFocus
                                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                                />
                                                <TextField
                                                    variant="outlined"
                                                    margin="normal"
                                                    required
                                                    sx={{ mr: 3, ml: 3 }}
                                                    id="new-password"
                                                    label={"Enter New Password"}
                                                    name="new-password"
                                                    autoComplete="new-password"
                                                    value={password}
                                                    type="password"
                                                    autoFocus
                                                    onChange={(e) => setPassword(e.target.value)}
                                                />
                                                <TextField
                                                    variant="outlined"
                                                    margin="normal"
                                                    required
                                                    sx={{ mr: 3, ml: 3 }}
                                                    id="confirm-password"
                                                    label={"Confirm Password"}
                                                    name="confirm-password"
                                                    autoComplete="confirmpassword"
                                                    type="password"
                                                    value={confirmPassword}
                                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                                />


                                                <Button
                                                    type="submit"
                                                    // fullWidth
                                                    variant="contained"
                                                    color="primary"
                                                    sx={{ m: 3 }}
                                                    onClick={submitHandler}
                                                    disabled={submitActive}
                                                >
                                                    {"Update"}
                                                </Button>

                                            </FormGroup>
                                        </FormControl>
                                    </Box>
                                </Paper>
                            </Grid>
                        </Grid> :
                        <Loader />}
                </>
                :
                <Navigate to="/login" replace={true} />

            }

        </>
    )
}

export default ProfilePage